export function getActivitiesForRoutineID(state, routineID) {
  return (
    state.activities.idsBy.routineID[routineID]?.map(
      (id) => state.activities.byID[id]
    ) || []
  );
}
